var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RoundedButton"},[_vm._t("icon",function(){return [_vm._v("Icon")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }